import { createInstance, type i18n as I18nInstance } from "i18next";
import { initReactI18next } from "react-i18next";

import enTranslations from "../locales/en.json";
import elTranslations from "../locales/el.json";
import { supportedLocales, type Locale } from "./utils";

const resources = {
  el: { translation: elTranslations },
  en: { translation: enTranslations },
} as const;

/**
 * Create an isolated i18n instance for a specific locale.
 *
 * Critical for static export:
 * - No global singleton reused across / and /en during build
 * - Language is set synchronously before first render (no useEffect switching)
 */
export function createI18n(locale: Locale): I18nInstance {
  const instance = createInstance();

  instance.use(initReactI18next).init({
    resources,
    lng: locale,
    supportedLngs: [...supportedLocales],
    fallbackLng: "en",
    defaultNS: "translation",
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
    // Ensure init happens synchronously during render (static export / prerender).
    initImmediate: false,
  });

  return instance;
}

